import React, { Component } from 'react';
import '../../scss/components/_user-testimony-card.scss'

class UserTestimonyCard extends Component {

    constructor(props){
        super(props);

        if(props.readMoreButton!=""){
            this.state = {readMoreButton:<p className="mb-0">{this.props.footer?this.props.footer:<a>Read more on </a>}
                <a href={this.props.readMoreLink}  target="_blank" className="ctaStandard"> {this.props.readMoreText} </a></p>}
        }else{
            this.state = {readMoreButton: ""}
        }  
    }
    render(){
        if(!this.props.imbalanced){
            return (
                <div className="fullWidthTestimonyCard">
                    <div className="logoContainer">
                        <img src={this.props.logo} alt="logo" />
                    </div>
                    <div className="testimonialContent">
                        {this.props.testimony}
                        <div className="testimonyAuthor">
                            <img src={this.props.image} alt={this.props.name}  />
                            <div className="d-flex flex-column">
                                <p className="my-0"><b>{this.props.name} </b></p>
                                <p className="my-0 minorBlueHeader text-left">{this.props.position} </p>
                            </div>
                        </div>
                        {this.state.readMoreButton}
                    </div>
                </div>
                )
            } else {
                return (
                <div className="fullWidthTestimonyCard-imbalanced">
                    <div className="testimonialContent">
                        {this.props.testimony}
                        <div className="testimonyAuthor">
                            <img src={this.props.image} alt={this.props.name} />
                            <div className="d-flex flex-column">
                                <p className="my-0"><b>{this.props.name}</b></p>
                                <p className="my-0 minorBlueHeader text-left">{this.props.position}</p>
                            </div>
                        </div>
                        {this.state.readMoreButton}
                    </div>
                    <div className="logoContainer">
                        <img src={this.props.logo} alt="logo" />
                    </div>
                </div>
                )
            }
        }
}

export default UserTestimonyCard;
